import Arbitrage from "./Arbitrage";

export default {
    Arbitrage
};


// WEBPACK FOOTER //
// ./src/services/API/components/AdContent/index.js